import React from "react";
import "./home-first.css";
import "./home-second.css";
import Template from "../../components/template/Template";
import PageButton from "../../components/general/PageButton";
import HomeText from "./components/hometext";
import HomeImage from "./components/homeimage";

import MainBackground from "../../components/template/MainBackground";
import HomeSeparator from "./components/homeSeparator";
function Home() {
  return (
    <Template>
      <div className="home-first-part">
        <MainBackground>
          <div className="home-title">
            <h3 style={{ marginTop: "3vh", marginBottom: "5vh" }}>
              Contrôle + Réparation
            </h3>
          </div>
          <div className="home-rdv">
            <div className="home-rdv-container">
              <div className="home-rdv-title">
                <h2>DÉPANNAGE ET SERVICES INFORMATIQUE À DOMICILE 7/7j</h2>
              </div>
              <div className="home-rdv-text">
                Une panne ne signifie pas toujours une réparation coûteuse.
                <br /> Nos diagnostics permettent d'estimer rapidement le coût
                de la réparation.
              </div>
              <div className="home-rdv-button-container">
                <PageButton page="/contacts#top-page">
                  Appelez-nous pour une estimation gratuite
                </PageButton>
                <div className="home-rdv-textB"></div>
              </div>
              <div className="home-rdv-text">
                Votre ordinateur à besoin d'un nettoyage ou d'une optimisation ?{" "}
                <br />
                Vous souhaitez transférer vos données sur un nouveau PC ? Ou
                vous avez besoin de conseils ?
              </div>
              <div className="home-rdv-button-container">
                <PageButton page="/tarifs#top-page">
                  Consultez la liste de nos services
                </PageButton>
              </div>
            </div>
          </div>
        </MainBackground>
      </div>

      <div className="home-second-part">
        <h1 className="home-second-title">NOS SERVICES</h1>
        <div className="home-second-intro" style={{ paddingBottom: "0px" }}>
          <HomeText
            title="Dépannage et réparation informatique - À domicile ou en atelier"
            w="40%"
          >
            <p breakWord="true">
              Votre ordinateur est lent, en panne ou infecté par un virus ?
              Besoin d'une installation, d'un conseil ou d'un dépannage rapide ?
            </p>
            Que vous soyez un particulier ou une entreprise, nous proposons des
            services de réparation, d'optimisation et de maintenance adaptés à
            vos besoins. Intervention rapide à domicile ou en atelier,
            changement de pièces, installation de logiciels, montage de PC,
            création de sites web et solutions informatiques pour
            professionnels. Contactez-nous dès maintenant pour une prise en
            charge efficace et sans prise de tête !
          </HomeText>
          <HomeImage
            imageName="Dev.jpg"
            w="35%"
            h="400px"
            target="contacts#top-page"
          />
        </div>
        <HomeSeparator w="70%" t="30px" b="0px" />
        <HomeSeparator w="45%" t="20px" b="100px" />
        <div className="home-second-button-container">
          <PageButton page="/tarifs#tarifs-details">
            Liste détaillée des services
          </PageButton>
        </div>
        <HomeSeparator w="45%" t="100px" b="20px" />
        <HomeSeparator w="70%" t="0px" b="30px" />
        <div className="home-second-intro">
          <HomeImage
            imageName="motherboard.jpg"
            w="35%"
            h="400px"
            target="tarifs#tarifs-details"
          />
          <HomeText title="💻 Réparation et dépannage informatique" w="40%">
            Votre PC ou Mac ne fonctionne plus correctement ? Nous
            diagnostiquons et réparons tous types de pannes : écran noir,
            lenteurs, faux contacts, problèmes de démarrage… Que ce soit un
            souci matériel ou logiciel, nous trouvons la solution adaptée pour
            redonner vie à votre ordinateur.
          </HomeText>
        </div>
        <div className="home-second-intro">
          <HomeText title="🚀 Accélération et optimisation" w="40%">
            Un ordinateur lent peut être frustrant ! Nous optimisons les
            performances de votre machine : nettoyage des fichiers inutiles,
            mise à jour du matériel (SSD, RAM…), suppression des logiciels
            indésirables et optimisation du système d’exploitation pour un PC
            plus rapide et plus fluide.
          </HomeText>
          <HomeImage
            imageName="Maintenance.jpg"
            w="35%"
            h="400px"
            target="tarifs#tarifs-details"
          />
        </div>
        <div className="home-second-intro">
          <HomeImage imageName="montage.jpg" target="tarifs#tarifs-details" />
          <HomeText title="🔧 Remplacement de pièces et montage PC" w="40%">
            Besoin d’un nouvel écran, d’un disque dur plus performant ou d’une
            carte graphique ? Nous remplaçons vos composants défectueux et
            montons votre PC sur mesure, que ce soit pour le gaming, le travail
            ou la bureautique.
          </HomeText>
        </div>
        <div className="home-second-intro">
          <HomeText
            title="🦠 Désinfection et protection contre les virus"
            w="40%"
          >
            Votre ordinateur est infecté par un virus, un malware ou un logiciel
            espion ? Nous supprimons toutes les menaces et installons des
            solutions de protection efficaces pour sécuriser vos données et
            éviter toute intrusion.
          </HomeText>
          <HomeImage
            imageName="dust.jpg"
            w="35%"
            h="400px"
            target="tarifs#tarifs-details"
          />
        </div>
        <div className="home-second-intro">
          <HomeImage
            imageName="install.jpg"
            w="35%"
            h="400px"
            target="tarifs#tarifs-details"
          />
          <HomeText title="📦 Installation et configuration" w="40%">
            Nous installons et configurons votre système d’exploitation
            (Windows, macOS, Linux) ainsi que vos logiciels essentiels pour une
            prise en main facile et sécurisée.
          </HomeText>
        </div>
        <div className="home-second-intro">
          <HomeText title="🏢 Services pour les entreprises" w="40%">
            Nous accompagnons les professionnels avec des solutions adaptées :
            <br />
            <br />
            ✔️ Contrats de maintenance et de dépannage régulier
            <br />
            ✔️ Développement de petits logiciels sur mesure
            <br />
            ✔️ Création de sites web vitrine
            <br />
            ✔️ Audits et conseils pour une meilleure utilisation de vos outils
            informatiques
          </HomeText>
          <HomeImage
            imageName="Conseil.jpg"
            w="35%"
            h="400px"
            target="tarifs#tarifs-details"
          />
        </div>
      </div>
    </Template>
  );
}

export default Home;
